import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LotPopupService } from './lot-popup.service';
import { JhiEventManager } from '../../shared/core-utils';
import { Lot } from '../../shared/inventory/model/lot.model';

@Component({
    selector: 'jhi-lot-dialog',
    templateUrl: './lot-dialog.component.html'
})
export class LotDialogComponent implements OnInit {

    lot: Lot;
    isSaving: boolean;

    constructor(
        public activeModal: NgbActiveModal,
        private eventManager: JhiEventManager
    ) {
    }

    ngOnInit() {
        this.isSaving = false;
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    save() {
        this.isSaving = true;
    }

    private onSaveSuccess(result: Lot) {
        this.eventManager.broadcast({ name: 'lotListModification', content: 'OK' });
        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError() {
        this.isSaving = false;
    }
}

@Component({
    selector: 'jhi-lot-popup',
    template: ''
})
export class LotPopupComponent implements OnInit, OnDestroy {

    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private lotPopupService: LotPopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe((params) => {
            if ( params['id'] ) {
                this.lotPopupService
                    .open(LotDialogComponent as Component, params['id']);
            } else {
                this.lotPopupService
                    .open(LotDialogComponent as Component);
            }
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}
